import { Checkbox } from "@mui/material"
import FormControlLabel from "@mui/material/FormControlLabel"
import styled from "styled-components"

export const OptionWrapper = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 0.875rem;
  }

  .price {
    color: ${({ theme }) => theme.palette.primaryColor};
  }
`
export const CustomCheckbox = styled(Checkbox)`
  color: ${({ theme }) => theme.palette.primaryColor};

  &.Mui-checked {
    color: ${({ theme }) => theme.palette.primaryColor};

    .MuiIconButton-label {
      &:after {
        content: "";
        background-color: ${({ theme }) => theme.palette.primaryColor};
        width: 18px;
        height: 18px;
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 2px;
        transform: translate(-50%, -50%);
      }
    }
  }
`
